import { h, Component } from 'preact';
import style from './index.less';
import {Sessions, TimeSlots, CollectInformation, Confirmation, Receipt, Payment} from 'components/templates'
import {Steps} from 'components/groups'
import {Page, Footer} from 'components/elements'
import { Provider, connect } from 'react-redux';
import store from 'reducers'
import { LocaleActions } from 'actions';


@connect((state)=>(
	{
		...state,
		access: ((state.session || {}).organizations || []).find((_)=> _.id == state.organization.id)
	}
))
class Widget extends Component {
	constructor(){
		super();
		this.state = {
			size: 'sm'
		};
		const _onresize = document.onresize 
		window.addEventListener('resize', (e)=>{
			this.handleWidth()
		})
	}
	componentDidMount(){
		this.handleWidth()
	}

	handleWidth(){
		let size;
		if((this.mainElement || {}).clientWidth < 768){
			size = 'sm'
		}else if((this.mainElement || {}).clientWidth < 992){
			size = 'md'
		}else{
			size = 'lg'
		}

		this.setState({
			size
		})
	}
	setLocale(locale, e) {
		e.preventDefault()
		LocaleActions.setLocale(locale)
	}
	render() {
		const classes = [style.widgetContainer, this.state.size]
		this.props.roboto != false && classes.push('roboto')

		return (
			<div class={classes.join(' ')} ref={(_)=> this.mainElement = _}>
				{this.props.roboto != false && (
					<link href="https://fonts.googleapis.com/css?family=Roboto" rel="stylesheet" />
					)}
				<link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.6.3/css/all.css" integrity="sha384-UHRtZLI+pbxtHCWp1t77Bi1L4ZtiqrqD80Kn4Z8NTSRyMA2Fd33n5dQ8lWUE00s/" crossorigin="anonymous" />
				<a href="#" onClick={this.setLocale.bind(null, "en")}>English</a> &nbsp;
				<a href="#" onClick={this.setLocale.bind(null, "esp")}>Español</a> &nbsp;
				<a href="#" onClick={this.setLocale.bind(null, "fr")}>French</a>
				{!this.props.config.hideSteps && 
					<Steps />
				}
				<div>
					<Page componentPage={'sessions'} component={Sessions} />
					<Page componentPage={'timeSlots'} component={TimeSlots} />
					<Page componentPage={'collectInformation'} component={CollectInformation} />
					<Page componentPage={'confirmation'} component={Confirmation} />
					<Page componentPage={'receipt'} component={Receipt} />
					<Page componentPage={'payment'} component={Payment} />
				</div>
				<Footer />
			</div>
		);
	}
}

export default ()=>(
	<Provider store={store}>
		<Widget />
	</Provider>
)


// WEBPACK FOOTER //
// ./components/widget/index.js